import api from './api'
import { Employee, CreateEmployeeRequest } from './types'

export const employeesService = {
  /**
   * Get all employees
   */
  async getAll(params?: {
    is_active?: boolean
    is_ownership_eligible?: boolean
    primary_company?: number
    search?: string
  }): Promise<Employee[]> {
    const response = await api.get<Employee[]>('/employees/', { params })
    return response.data
  },

  /**
   * Get employee by ID
   */
  async getById(id: number): Promise<Employee> {
    const response = await api.get<Employee>(`/employees/${id}/`)
    return response.data
  },

  /**
   * Create employee
   */
  async create(data: CreateEmployeeRequest): Promise<Employee> {
    const response = await api.post<Employee>('/employees/', data)
    return response.data
  },

  /**
   * Update employee
   */
  async update(id: number, data: Partial<CreateEmployeeRequest>): Promise<Employee> {
    const response = await api.patch<Employee>(`/employees/${id}/`, data)
    return response.data
  },

  /**
   * Delete employee
   */
  async delete(id: number): Promise<void> {
    await api.delete(`/employees/${id}/`)
  },
}

export default employeesService
